var exports = {
  "XG": "Scroller.module__scroller___Mms5OG",
  "xG": "Scroller.module__scrollerTextarea___Mms5OG",
};

module.exports = exports;
